export const aether_path = "/aether";
export const authorize_kc_path = `${aether_path}/auth/kc`;
export const authorize_kc_idp_path = `${authorize_kc_path}/idp`;

export const authorize_kc_idp_saml_path = `${authorize_kc_idp_path}/saml`;
export const GET_SAML_INTEGRATIONS = `${authorize_kc_idp_saml_path}`;
export const CREATE_SAML = `${authorize_kc_idp_saml_path}/add`;
export const UPDATE_SAML = `${authorize_kc_idp_saml_path}/update`;
export const DELETE_SAML = `${authorize_kc_idp_saml_path}/delete`;

export const authorize_kc_idp_social_path = `${authorize_kc_idp_path}/social`;
export const authorize_kc_idp_social_microsoft_path = `${authorize_kc_idp_social_path}/microsoft`;
export const GET_SOCIAL_INTEGRATIONS = `${authorize_kc_idp_social_path}`;
export const CREATE_MICROSOFT = `${authorize_kc_idp_social_microsoft_path}/create`;
export const UPDATE_MICROSOFT = `${authorize_kc_idp_social_microsoft_path}/update`;
export const DELETE_MICROSOFT = `${authorize_kc_idp_social_microsoft_path}/delete`;

export const authorize_kc_idp_oidc_path = `${authorize_kc_idp_path}/oidc`;
export const GET_OIDC_INTEGRATIONS = `${authorize_kc_idp_oidc_path}`;
export const CREATE_OIDC = `${authorize_kc_idp_oidc_path}/add`;
export const UPDATE_OIDC = `${authorize_kc_idp_oidc_path}/update`;
export const DELETE_OIDC = `${authorize_kc_idp_oidc_path}/delete`;
